/**
 * Wealth Series tier ownership (TRAD-1317).
 *
 * The v3 tiers (Pulsar, Ranger, Falcon, Quantum) are sold on their own with
 * their own feature flags (wealth_series_<tier> and wealth_series_<tier>_auto,
 * from the TradeAlgo Plans sheet), and the black_box flag still grants all
 * four (TRAD-1246). The sidebar badges and the paywall chips both decide
 * ownership here so the two never disagree.
 */

export const WEALTH_SERIES_V3_TIERS = ["pulsar", "ranger", "falcon", "quantum"];

const capitalize = (tier) => tier.charAt(0).toUpperCase() + tier.slice(1);

/** `{ hasWealthSeriesPulsar, hasWealthSeriesPulsarAuto, ... }` from the user's feature flags. */
export const readWealthSeriesV3Flags = (featureFlags) =>
  WEALTH_SERIES_V3_TIERS.reduce((flags, tier) => {
    const name = capitalize(tier);
    flags[`hasWealthSeries${name}`] =
      !!featureFlags?.[`wealth_series_${tier}`]?.active;
    flags[`hasWealthSeries${name}Auto`] =
      !!featureFlags?.[`wealth_series_${tier}_auto`]?.active;
    return flags;
  }, {});

/**
 * Whether the signed-in user owns a Wealth Series tier, given the Auth
 * context values. Core has no auto plan; the v3 tiers also come with Black Box.
 */
export const ownsWealthSeriesTier = (auth, tier) => {
  switch (tier) {
    case "core":
      return !!auth.hasWealthSeriesCore;
    case "atlas":
    case "titan":
    case "everest":
    case "pulsar":
    case "ranger":
    case "falcon":
    case "quantum": {
      const name = capitalize(tier);
      const owned =
        !!auth[`hasWealthSeries${name}`] ||
        !!auth[`hasWealthSeries${name}Auto`];
      return WEALTH_SERIES_V3_TIERS.includes(tier)
        ? owned || !!auth.hasBlackBox
        : owned;
    }
    default:
      return false;
  }
};
